import React from 'react';
import "../GuidedExperience/GuidedExperienceWizard.css";
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../utils/formatter';
import { Option } from '../common/Dropdown/Dropdown';

interface MultiresSummaryWizardProps {
    parkings: Record<string, unknown>;
    hasParking: boolean;
    calculteFinalSuites: () => Record<string, unknown>;
    isBasePropType: boolean;
    styleOptions: Option[];
    unitTypeSubtypeMap: Record<string, Option[]>;
    multiresUnitSubtype: Record<string, unknown>[];
    multiresRowHouseUnitSubtype: Record<string, unknown>[];
}

export default function MultiresSummaryWizard(props: MultiresSummaryWizardProps): JSX.Element {
    const { t } = useTranslation("guided_wizard");
    const currencySymbol = "$";

    const convertToUnits = () => {
        const finalSuites = props.calculteFinalSuites().finalSuites;
        const generated: Record<string, unknown>[] = []

        for (const [suiteType, numberObject] of Object.entries(finalSuites as Record<string, unknown>)) {
            for (const [typeCode, amt] of Object.entries(numberObject as Record<string, unknown>)) {
                if (props.isBasePropType) {
                    const newUnit = {
                        unitSubtypeCode: typeCode,
                        styleTypeCode: suiteType,
                        unitCount: amt
                    }
                    generated.push(newUnit)
                } else {
                    for (let i = 0; i < (amt as number); i++) {
                        const newUnit = {
                            unitSubtypeCode: typeCode,
                            styleTypeCode: suiteType,
                            unitCount: 1
                        }
                        generated.push(newUnit)
                    }
                }
            }
        }

        return generated;
    }

    return (<div>
        <p>{props.hasParking ? t("multires-summary-wizard.multires-summary-update-description") : t("multires-summary-wizard.multires-summary-description")}</p>
        {props.hasParking ? <table className='wizard-table' role='presentation'>
            <thead>
                <tr>
                    <td></td>
                    <th>{t("apartment-headings.spaces-not-in-rent")}</th>
                    <th>{t("apartment-headings.monthly-rate")}</th>
                    <th>{t("apartment-headings.spaces-in-rent")}</th>
                    <th>{t("apartment-headings.total-spaces")}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><b>{t("apartment-headings.surface")}</b></td>
                    <td className='no-input-cell'>{props.parkings["residentialSurfaceParkingNotInRent"] as string}</td>
                    <td className='no-input-cell'>{props.parkings["residentialSurfaceParkingMonthlyRate"] ? currencySymbol + formatCurrency(props.parkings["residentialSurfaceParkingMonthlyRate"] as number, "en") : ""}</td>
                    <td className='no-input-cell'>{props.parkings["residentialSurfaceParkingInRent"] as string}</td>
                    <td className='no-input-cell'>{props.parkings["residentialSurfaceParkingTotal"] as string}</td>
                </tr>
                <tr>
                    <td><b>{t("apartment-headings.indoor")}</b></td>
                    <td className='no-input-cell'>{props.parkings["residentialIndoorParkingNotInRent"] as string}</td>
                    <td className='no-input-cell'>{props.parkings["residentialIndoorParkingMonthlyRate"] ? currencySymbol + formatCurrency(props.parkings["residentialIndoorParkingMonthlyRate"] as number, "en") : ""}</td>
                    <td className='no-input-cell'>{props.parkings["residentialIndoorParkingInRent"] as string}</td>
                    <td className='no-input-cell'>{props.parkings["residentialIndoorParkingTotal"] as string}</td>
                </tr>
            </tbody>
        </table> :
            <table className='wizard-table' role='presentation'>
                <thead>
                    <tr>
                        <th key="confirm-units-wizard-heading-1">{t("style", { ns: "suite_breakdown_table" })}</th>
                        <th key="confirm-units-wizard-heading-2">{t("type", { ns: "suite_breakdown_table" })}</th>
                        {props.isBasePropType && <th key="confirm-units-wizard-heading-3">{t("unitCount", { ns: "suite_breakdown_table" })}</th>}
                    </tr>
                </thead>
                <tbody>
                    {convertToUnits().map((unit, index) => <tr key={`summary-unit-row-${index}`}>
                        <td className='no-input-cell'>
                            <label>{(props.styleOptions.find((style) => style["value"] === unit["styleTypeCode"]) ?? { "text": "" })["text"] as string}</label>
                        </td>
                        <td className='no-input-cell'>
                            <p className='no-wrap'>{((unit["styleTypeCode"] === "1" ? props.multiresUnitSubtype : props.multiresRowHouseUnitSubtype).find((subtype) => subtype["unitSubtypeCode"] === unit["unitSubtypeCode"]) ?? { "unitSubtypeDescription": "" })["unitSubtypeDescription"] as string}</p>
                        </td>
                        {props.isBasePropType && <td className='no-input-cell'>
                            <p>{unit["unitCount"] as string}</p>
                        </td>}
                    </tr>)}
                </tbody>
            </table>
        }
    </div>)
}
